import { forwardRef, useEffect, useState } from "react";
import Select from "react-select";
import { hrService } from "../../../services/hr.services";
import { IOption } from "Dashboard/domain/IOption";

const EmployeeRoleSelect = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IOption[]>([]);
  const { value, setValue } = props;
  const [valueLocal, setValueLocal] = useState<IOption | undefined>(undefined);

  useEffect(() => {
    async function getData() {
      try {
        const roles = await hrService.getAllEmployeeRoles();
        const op = roles.map((role) => {
          return {
            label: role.roleName,
            value: role.roleId,
          };
        });
        setOptions(op);
        setIsLoading(false);
      } catch (err) {
        console.log(err);
      }
    }
    getData();
  }, []);

  useEffect(() => {
    if (props.defaultValue) {
      const values = options.filter((o) => o.value === props.defaultValue);
      if (values[0]) {
        handleChange(values[0], null);
      } else setValueFunction(undefined);
    }
  }, [options, props.defaultValue]);

  const getValue = () => {
    if (value) {
      const values = options.filter((o) => o.value === value);
      if (values[0]) {
        return values[0];
      }
    }
    return valueLocal;
  };

  const setValueFunction = (option: IOption | undefined) => {
    if (setValue) {
      setValue(option);
    }
    setValueLocal(option);
  };

  const handleChange = (newValue: any, actionMeta: any) => {
    setValueFunction(newValue);
    props.onChange(newValue ? newValue.value : null);
  };

  return (
    <Select
      isClearable
      menuPosition="fixed"
      styles={props.styles}
      ref={ref}
      options={options}
      value={getValue()}
      onChange={handleChange}
      placeholder={""}
      noOptionsMessage={() => "Ne postoji"}
      isLoading={isLoading}
      {...{ error: props.error }}
    />
  );
});

export default EmployeeRoleSelect;
